import React from "react";
import {
  AppBar,
  Toolbar,
  Container,
  Box,
  Typography,
  IconButton,
  Button,
  TextField,
  InputAdornment,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MailIcon from "@mui/icons-material/Mail";
import FilterListIcon from "@mui/icons-material/FilterList";
import LayersIcon from "@mui/icons-material/Layers";

export default function TopBar({ 
  brandCounts, 
  categoryCounts, 
  total, 
  query, 
  setQuery, 
  onOpenOrder, 
  onOpenFilters 
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <AppBar 
      position="sticky" 
      color="default" 
      elevation={0} 
      sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "background.paper" }}
    >
      <Toolbar sx={{ justifyContent: "space-between", px: { xs: 1, sm: 2 }, minHeight: { xs: 56, sm: 64 } }}>
        <Box display="flex" alignItems="center" gap={1}>
          {isMobile && (
            <IconButton onClick={onOpenFilters} sx={{ mr: 1 }}>
              <FilterListIcon />
            </IconButton>
          )}
          <Box sx={{ 
            width: { xs: 36, sm: 44 }, 
            height: { xs: 36, sm: 44 }, 
            borderRadius: 2, 
            bgcolor: "text.primary", 
            color: "common.white", 
            display: "grid", 
            placeItems: "center" 
          }}>
            <LayersIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
          </Box>
          {!isMobile && (
            <Box>
              <Typography variant="h6" sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                Premium Catalog
              </Typography>
            </Box>
          )}
        </Box>

        <Box sx={{ 
          display: "flex", 
          alignItems: "center", 
          gap: { xs: 1, sm: 2 }, 
          flex: 1, 
          mx: { xs: 1, sm: 2 },
          maxWidth: { xs: 'none', sm: 600 }
        }}>
          <TextField
            fullWidth
            size="small"
            placeholder={isMobile ? "Search..." : "Search products, brands, tags…"}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            InputProps={{ 
              startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment> 
            }}
            sx={{ '& .MuiOutlinedInput-root': { fontSize: { xs: '0.875rem', sm: '1rem' } } }}
          />
        </Box>

        <Box display="flex" alignItems="center" gap={1}>
          {!isMobile && (
            <Typography variant="caption" color="text.secondary" sx={{ mr: 1 }}>
              Prices: USD
            </Typography>
          )}
          <Button 
            variant="contained" 
            onClick={onOpenOrder} 
            startIcon={!isMobile ? <MailIcon /> : null}
            size={isMobile ? "small" : "medium"}
            sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
          >
            {isMobile ? "Order" : "How to Order"}
          </Button>
        </Box>
      </Toolbar>

      {!isMobile && (
        <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2 } }}>
          <Box sx={{ 
            display: "flex", 
            gap: 2, 
            py: 1, 
            fontSize: { xs: 10, sm: 12 }, 
            color: "text.secondary", 
            flexWrap: 'wrap' 
          }}>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="body2">{total} products</Typography>
            </Box>
            <Box sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              <strong>Brands:</strong> {Object.keys(brandCounts).slice(0,6).join(", ")}{Object.keys(brandCounts).length>6?"…":""}
            </Box>
            <Box sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              <strong>Categories:</strong> {Object.keys(categoryCounts).slice(0,6).join(", ")}{Object.keys(categoryCounts).length>6?"…":""}
            </Box>
          </Box>
        </Container>
      )}
    </AppBar>
  );
}